import { HttpErrorResponse } from '@angular/common/http';

import { VALIDATION_MESSAGES } from '@core/utils/validation-messages';

export function systemAdminsErrorMessage(
  error: HttpErrorResponse,
  message?: string
): string {
  const serverError = error?.error || {};

  switch (true) {
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'email_already_verified'
    ):
      return VALIDATION_MESSAGES.EmailAlreadyVerified;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'name_already_exists'
    ):
      return VALIDATION_MESSAGES.NameAlreadyExists;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'email_already_exists'
    ):
      return VALIDATION_MESSAGES.EmailAlreadyExists;
    case Object.prototype.hasOwnProperty.call(serverError, 'user_not_found'):
      return VALIDATION_MESSAGES.UserNotFound;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'cannot_change_current_account'
    ):
      return VALIDATION_MESSAGES.CannotChangeCurrentAccount;
    case Object.prototype.hasOwnProperty.call(serverError, 'account_not_found'):
      return VALIDATION_MESSAGES.AccountNotFound;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'invalid_sort_column'
    ):
      return VALIDATION_MESSAGES.InvalidSortColumn;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'abbreviation_already_exists'
    ):
      return VALIDATION_MESSAGES.AbbreviationAlreadyExists;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'invalid_module_ids'
    ):
      return VALIDATION_MESSAGES.InvalidModuleIds;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'specified_client_does_not_exist'
    ):
      return VALIDATION_MESSAGES.ClientDoesNotExist;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'account_activation_failed'
    ):
      return VALIDATION_MESSAGES.AccountActivationFailed;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'invalid_account_activation_request'
    ):
      return VALIDATION_MESSAGES.InvalidAccountActivationRequest;
    case Object.prototype.hasOwnProperty.call(serverError, 'id_does_not_match'):
      return VALIDATION_MESSAGES.IdDoesNotMatch;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'invalid_status_change_for_user_in_pending_state'
    ):
      return VALIDATION_MESSAGES.InvalidStatusChange;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'invalid_project_module_access_association'
    ):
      return VALIDATION_MESSAGES.InvalidProjectModuleAccessAssociation;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'a_delete_request_already_exists_for_this_account'
    ):
      return VALIDATION_MESSAGES.DeleteAccountRequestAlreadyExists;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'a_delete_request_does_not_exist_for_this_account'
    ):
      return VALIDATION_MESSAGES.DeleteAccountRequestDoesNotExists;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'a_system_admin_can_have_a_single_account'
    ):
      return VALIDATION_MESSAGES.SystemAdminSingleAccount;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'an_account_already_exists_for_this_client'
    ):
      return VALIDATION_MESSAGES.AccountAlreadyExistsForClient;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'no_rights_for_current_account'
    ):
      return VALIDATION_MESSAGES.NoRightsForCurrentAccount;
    default:
      return message ?? 'Unknown error';
  }
}

export function isEmailAlreadyVerifiedError(
  httpError: HttpErrorResponse | null
): boolean {
  if (!httpError) {
    return false;
  }

  const serverError: Record<string, unknown> = httpError.error ?? {};

  return Object.prototype.hasOwnProperty.call(
    serverError,
    'email_already_verified'
  );
}
